/*
  Project: Ajman University
  Author: Xfive
 */

import Popper from 'popper.js';

window.Popper = Popper;

require('bootstrap');

import mainNav from './mainNav.es6';
import modalSearch from './modalSearch.es6';
import sliders from './sliders.es6';
import gallery from './gallery.es6';
import smothScroll from './smothScroll.es6';
import modal from './modal.es6';
import dropdownNav from './dropdownNav.es6';
import calendar from './calendar.es6';
// import flip from './flip.es6';

mainNav();
modalSearch();
sliders();
gallery();
smothScroll();
modal();
dropdownNav();
calendar();
// flip();